function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { bool, func, node, oneOfType, shape, string } from "prop-types";
import deprecated from "prop-types-extra/lib/deprecated";
export var fieldContainerTypes = {
  children: node.isRequired,
  dataSpacer: string,
  className: string,
  hasError: bool,
  isDisabled: bool,
  tag: string
};
export var fieldLabelTypes = {
  label: node.isRequired,
  className: string,
  required: bool,
  isDisabled: bool,
  notRequiredText: node,
  dataSpacerLabel: string
};
export var fieldWrapperTypes = {
  children: node.isRequired,
  className: string,
  dataSpacer: string
};
export var fieldIconTypes = {
  icon: string.isRequired,
  onIconClick: func,
  className: string,
  hasIconOnLeft: bool,
  isDisabled: bool
};
export var fieldSwitchTextTypes = {
  hasError: bool,
  className: string,
  helpText: node,
  errorText: node
};
export var fieldLayoutTypes = {
  commonProps: shape({
    id: deprecated(string, "Put it in fieldProps instead"),
    hasError: bool
  }),
  containerProps: oneOfType([shape(_objectSpread({}, fieldContainerTypes)), shape({})]),
  labelProps: oneOfType([shape(_objectSpread({}, fieldLabelTypes)), shape({})]),
  fieldWrapperProps: oneOfType([shape(_objectSpread({}, fieldWrapperTypes)), shape({})]),
  iconProps: oneOfType([shape(_objectSpread({}, fieldIconTypes)), shape({})]),
  switchTextProps: oneOfType([shape(_objectSpread({}, fieldSwitchTextTypes)), shape({})])
};